var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stub"},[_c('span',{staticClass:"stub__icon"},[_c('SvgIcon',{attrs:{"name":"rotate-phone"}})],1),_c('span',{staticClass:"stub__text"},[_vm._v("Please rotate your phone to be vertical")])])
}
var staticRenderFns = []

export { render, staticRenderFns }